import {callTealiumLink, getDiff, moveFOB, unsubscribeAllHelper, unsubscribeUnknowns, getQueryParams, alphaSortInsensitiveLabel, sortByTypeCode} from '../utils/helpers';
import {constants} from '../utils/constants';

'use strict';
const _ = require('lodash');

let queryParams = getQueryParams();
const initialState = {
  // global state
  isSuppression: (window.isSender === 'true'),
  areAllUnchecked: false,
  permissionList: [],
  checkedList: [],
  originalPermissionList: [],
  hasChanges: false,
  lastUpdated: 0,
  ui: {
    hasSuccess: false,
    hasNLListSuccess: false,
    isFetching: true,
    firstFetch: true,
    hasError: false,
    errorCode: '',
    errorMessage: '',
    page: window.pageName,
    userHasInteracted: false
  },
};

// Process the raw data for an individual permission
function convertRawPermission(rawPermission, index) {
  // If we're processing a suppression permission there will not be a permissionStateCode property and it needs to
  // stay or be set to null
  var code = (_.isUndefined(rawPermission.permissionStateCode) || _.isNull(rawPermission.permissionStateCode)) ?
    null : rawPermission.permissionStateCode;

  // If for some reason there is not a code on this permission set the id to the index at which we received it from the API
  var id = (_.isUndefined(rawPermission.code) || _.isNull(rawPermission.code)) ? index : rawPermission.code;

  // TODO: Clean up and/or translate the default statement text when we actually use the statement text (This has been kept in the case we need to turn statement text back on at any point)
  // If there is no statement text provided set a default string to display instead
  // var statementText = constants.permissionStatementMissing;
  // if (_.has(rawPermission, constants.permissionStatementKey) && _.has(rawPermission.statement, constants.permissionStatementTextKey)) {
  //   statementText = rawPermission.statement.text;
  // }

  if (rawPermission.typeCode === constants.thirdPartyPermissionType || rawPermission.expired) {
    return {};
  }

  // Currenlty there is something going on with the API that it returns to us
  // permissions missing friendlyName when this happens use the code as the label
  var label = (_.isUndefined(rawPermission.friendlyName)) ? id : rawPermission.friendlyName;

  return {
    id: id,
    type: constants.itemPermissionType,
    label: label,
    // statement: statementText,
    stateCode: code,
    typeCode: rawPermission.typeCode,
  };
}

// Create a sub list of child permissions to be included after their parent
function processChildren(parent, parentIndex) {
  var childrenList = [];
  // If the provided permission has child permissions process them and return them to be listed under their parent
  if (parent.children) {
    _.each(parent.children, function (child, index) {
      var childIndex = parentIndex + '-' + index;
      childrenList.push(convertRawPermission(child, childIndex));
    });
  }

  return childrenList;
}

// Sort out the categories and create new ones if they don't already exist
function processCategory(permission, id, name, index, builder) {
  if (_.indexOf(_.keys(builder), name) === -1) {
    // If the provided category name is not already in the builder create it and add the current permission to the
    // category's children list. Then after it has been created process that permissions children so they are entered
    // into the list directly beneath their parent
    // Assign the typeCode of the permission creating the new category so we can move the FOB to the bottom of the list
    builder[name] = {
      type: constants.categoryPermissionType,
      id: id,
      label: name,
      children: [convertRawPermission(permission, index)],
      typeCode: permission.typeCode,
      senderName: permission.suppressionEntityName
    };
    builder[name].children.push(...processChildren(permission, index));
  } else {
    // If the provided category name already exists in the builder push the new permission into the children list and
    // then add their children
    builder[name].children.push(convertRawPermission(permission, index));
    builder[name].children.push(...processChildren(permission, index));
  }

  // remove any empty objects from the children array
  _.remove(builder[name].children, _.isEmpty);
  // If there are no permissions in the category remove it
  if (_.isUndefined(builder[name].children) || _.isEmpty(builder[name].children)) {
    delete builder[name];
  } else {
    // Label if this category has at least one child in a subscribed state for the category uncheck/check all links
    _.each(builder[name].children, function (child) {
      if (child.stateCode === constants.enabledStateCode) {
        builder[name].hasCheck = true;
      }
    });
  }
}

// Process the entire payload we get from the GET
function processRawPermissions(data) {
  // Immediately sort the raw permissions then process them after sorting
  var rawPermissionsList = (_.isUndefined(data.consumerPermissions)) ? [] : data.consumerPermissions.sort(sortByTypeCode);
  _.forEach(rawPermissionsList, function (permission) {
    if (!_.isUndefined(permission.children)) {
      permission.children = permission.children.sort(sortByTypeCode);
    }
  });

  // Using this to build and categorize our permissions
  var permissionListBuilder = {};

  _.forEach(rawPermissionsList, function(permission, index) {
    // TODO: Remove temp. fix (if we decide we should)
    // Temp fix for permissions w/o category
    if (_.isUndefined(permission.categoryName)) {
      var catName = 'Other';
      var catId = _.replace(catName, / /g, '_');
    } else {
      var catName = permission.categoryName;
      var catId = _.replace(permission.categoryName, / /g, '_');
    }
    processCategory(permission, catId, catName, index, permissionListBuilder);
  });

  // Get our newly processed permissions from our permissionListBuilder and sort the categories
  var updatedPermissions = _.values(permissionListBuilder).sort(alphaSortInsensitiveLabel);

  // Move the FOB permission to the bottom of the list
  return moveFOB(updatedPermissions);
}

module.exports = (state = initialState, action) => {
  var isSender = window.isSender;
  let isSuppression = state.isSuppression;
  var areAllUnchecked = state.areAllUnchecked;

  switch (action.type) {
    case 'REQUEST_PERMISSIONS':
      return {
        ...state,
        ui: {...state.ui, isFetching: true},
      };

    case 'PERMISSION_SAVE':
    case 'RECEIVE_PERMISSIONS':
      // console.log("\nRaw permissions: ", action.data);
      let uiErrorCode = '';
      let uiErrorMessage = '';
      let uiHasError = false;
      let permissions = [];
      let updatedPermissions = [];
      let newHasChanges = false;
      if (_.has(action.data, constants.errorCodeKey)) {
        uiHasError = true;
        uiErrorCode = action.data.errorCode;
        if (_.has(action.data, constants.messageKey)) {
          uiErrorMessage = action.data.message;
        }
      } else {
        // If this is a no data to change save then we don't want to process it like we do raw permissions
        if (action.isFakeSave) {
          permissions = action.data;
        } else {
          permissions = processRawPermissions(action.data);
        }
        // If the permissions are empty here then we know we've gotten back
        // either expired or third party permissions redirect to the sender page
        // if this is already the sender page display the no data page or continue as normal
        let isSingleP = permissions.length === 1 && permissions[0].children.length === 1 && permissions[0].children[0].stateCode === constants.pendingStateCode;
        if ((_.isEmpty(permissions) && window.pageName === (constants.unsubscribePageName || constants.subscribePageName) && !isSender) || ( isSingleP )) {
          window.location.replace(window.location.href + ((window.location.href.indexOf('?') === -1) ? '?sender=true' : '&sender=true'));
        }
        // console.log('\nProcessed Permission List:', permissions);

        updatedPermissions = _.cloneDeep(permissions);
        let isUnsub = (window.pageName === constants.unsubscribePageName);

        let totalPermissions = 0;
        _.each(updatedPermissions, (cat) => {
          totalPermissions += cat.children.length;
        });

        //if it's the first time the page has been loaded && it's an unsub && there's more than one permission
        if (state.ui.firstFetch && isUnsub && totalPermissions > 1) {
          let unsubObj = unsubscribeUnknowns(updatedPermissions);
          updatedPermissions = unsubObj.permissions;
          isSuppression = false;
          areAllUnchecked = unsubObj.unsubAll;
        } else if (state.ui.firstFetch && window.pageName === constants.managePageName) {
          updatedPermissions = unsubscribeUnknowns(updatedPermissions).permissions;
          isSuppression = false;
        }

        let diff = getDiff(state.originalPermissionList, updatedPermissions);

        newHasChanges = !_.isEmpty(diff);

        if (action.type === 'PERMISSION_SAVE') {

          let saveType = '';

          let states = _.map(diff, constants.permissionStateKey);
          let hasEnabled = _.indexOf(states, constants.enabledStateCode) !== -1;
          let hasDisabled = _.indexOf(states, constants.disabledStateCode) !== -1;

          if (action.isFakeSave || !newHasChanges) {
            saveType = constants.fakeSaveType;
          } else if (areAllUnchecked && !isSuppression) {
            saveType = constants.unsubAllSaveType;
          } else if (isSuppression) {
            saveType = constants.suppressionSaveType;
          } else if (hasEnabled && hasDisabled) {
            saveType = constants.mixedSaveType;
          } else if (hasEnabled) {
            saveType = constants.enableSomeSaveType;
          } else {
            saveType = constants.unsubSomeSaveType;
          }

          callTealiumLink({outcome: constants.successSaveOutcome, saveType: saveType});
        }
      }

      return {
        ...state,
        ui: {
          ...state.ui,
          isFetching: false,
          firstFetch: false,
          hasError: uiHasError,
          errorCode: uiErrorCode,
          errorMessage: uiErrorMessage,
          userHasInteracted: false
        },
        areAllUnchecked: areAllUnchecked,
        hasChanges: newHasChanges,
        permissionList: updatedPermissions,
        lastUpdated: action.receivedAt,
        originalPermissionList: _.cloneDeep(permissions),
        isSuppression: isSuppression,
      };

    case 'PERMISSION_TOGGLE':
      var total = 0;
      var out = 0;

      var updatedPermissions = state.permissionList.map((permission) => {
        // First make sure we are looking at an actual permission and not a category
        if (permission.type === constants.categoryPermissionType) {
          permission.hasCheck = false;
          _.forEach(permission.children, function(child) {
            // toggle only the desired permission
            if (child.id === action.permission.id) {
              //use action.permission.stateCode to coerce multiple entries of same permission to state opposite of what the toggled checkbox was previously
              child.stateCode = (action.permission.stateCode === constants.enabledStateCode) ? constants.disabledStateCode : constants.enabledStateCode;
            }

            // Update if the category has a checked child or not
            if (child.stateCode === constants.enabledStateCode) {
              permission.hasCheck = true;
            }

            // count the number of opt-outs and total permissions
            total += 1;
            out += (child.stateCode !== constants.enabledStateCode ? 1 : 0);
          });
        } else {
          // toggle only the desired permission
          if (permission.id === action.permission.id) {
            //use action.permission.stateCode to coerce multiple entries of same permission to state opposite of what the toggled checkbox was previously
            permission.stateCode = (action.permission.stateCode === constants.enabledStateCode) ? constants.disabledStateCode : constants.enabledStateCode;
          }
          // count number of opt-outs and total permissions
          total += 1;
          out += (permission.stateCode !== constants.enabledStateCode ? 1 : 0);
        }

        return permission;
      });

      var diff = getDiff(state.originalPermissionList, updatedPermissions);

      var newHasChanges = !_.isEmpty(diff);

      var new_state = {
        ...state,
        hasChanges: newHasChanges,
        permissionList: updatedPermissions,
        isSuppression: isSender && out === total,
        areAllUnchecked: out === total,
        ui: {
          ...state.ui,
          userHasInteracted: true
        }
      };

      return new_state;

    case 'CATEGORY_TOGGLE':
      var total = 0;
      var out = 0;

      var updatedPermissions = state.permissionList.map((permission) => {
        // Make sure this is a category and is the category we want to toggle
        if (permission.type === constants.categoryPermissionType) {
          if (permission.id === action.category.id) {
            // Figure out if we want to check or uncheck all boxes
            if (action.category.hasCheck) {
              var newStateCode = constants.disabledStateCode;
              permission.hasCheck = false;
            } else {
              var newStateCode = constants.enabledStateCode;
              permission.hasCheck = true;
            }
            _.each(permission.children, function (child) {
              child.stateCode = newStateCode;
            });
          }

          // Count the number of opt-outs and total permissions
          _.each(permission.children, function (child) {
            total += 1;
            out += (child.stateCode !== constants.enabledStateCode ? 1 : 0);
          });
        } else {
          total += 1;
          out += (permission.stateCode !== constants.enabledStateCode ? 1 : 0);
        }

        return permission;
      });

      var diff = getDiff(state.originalPermissionList, updatedPermissions);

      var newHasChanges = !_.isEmpty(diff);

      var new_state = {
        ...state,
        hasChanges: newHasChanges,
        permissionList: updatedPermissions,
        isSuppression: isSender && (out === total),
        areAllUnchecked: out === total,
        ui: {
          ...state.ui,
          userHasInteracted: true
        }
      };

      return new_state;

    case 'UNSUBSCRIBE_ALL':
      var updatedPermissions = unsubscribeAllHelper(state.permissionList);

      var diff = getDiff(state.originalPermissionList, updatedPermissions);

      var newHasChanges = !_.isEmpty(diff);

      var new_state = {
        ...state,
        hasChanges: newHasChanges,
        permissionList: updatedPermissions,
        isSuppression: isSender,
        areAllUnchecked: true,
        ui: {
          ...state.ui,
          userHasInteracted: true
        }
      };

      return new_state;

    case 'ERROR':
      var new_state = {
        ...state,
        ui: {
          isFetching: false,
          hasSuccess: false,
          hasNLListSuccess: false,
          hasError: true,
          errorCode: action.code,
          errorMessage: action.message,
          userHasInteracted: false
        },
      };

      return new_state;

    case 'SUCCESS':
      var new_state = {
        ...state,
        ui: {
          isFetching: false,
          hasSuccess: true,
          hasNLListSuccess: false,
          hasError: false,
          errorCode: '',
          errorMessage: '',
          userHasInteracted: false
        },
      };

      return new_state;

    case 'NLLIST_SUCCESS':
      var new_state = {
        ...state,
        ui: {
          isFetching: false,
          hasSuccess: true,
          hasNLListSuccess: true,
          hasError: false,
          errorCode: '',
          errorMessage: '',
          userHasInteracted: false
        },
      };

      return new_state;

    case 'BACK':
      var new_state = {
        ...state,
        ui: {
          isFetching: false,
          hasSuccess: false,
          hasNLListSuccess: false,
          hasError: false,
          errorCode: '',
          errorMessage: '',
          userHasInteracted: false
        },
      };

      return new_state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/permissionList.js